import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { clearFormAction } from 'Redux/forms/formsActions';
import { updateProfile } from 'Redux/profile/profileThunks';
import { LOADING } from 'Redux/userInterface/userInterfaceConstants';
import { Text, Link, FlexPanel, Divider } from 'Common';
import { showToast } from 'Utils/toastUtils';
import DynamicFormContainer from 'ExtendedForm/DynamicForm/DynamicFormContainer';
import { t } from 'Utils/localization/i18next';
import { trimAllObjPropertiesSkipPasswords } from 'Utils/object/objectUtils';
import styles from './DashboardPrimaryAddressSectionReadContainer.module.scss';

class DashboardPrimaryAddressSectionReadContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { isEditing: false };
    this.myRef = React.createRef();
  }

  onEdit = () => {
    this.setState({ isEditing: true });
  };

  onClose = () => {
    this.setState({ isEditing: false }, () => {
      this.props.clearFormAction(this.props.editForm);
      this.scrollToCenter();
    });
  };

  onSubmit = async data => {
    const newProfile = { ...this.props.profile, ...data };
    const success = await this.props.updateProfile(
      trimAllObjPropertiesSkipPasswords(newProfile),
      this.props.editForm
    );
    if (success) {
      showToast(
        t('dashboard.confirmation.addressPrimarySectionUpdateTitle'),
        t('dashboard.confirmation.addressPrimarySectionUpdateText')
      );
      this.setState({ isEditing: false });
    }
    this.scrollToCenter();
  };

  scrollToCenter = () => {
    if (this.myRef) {
      this.myRef.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  setRef = node => {
    if (node) {
      this.myRef = node;
    }
  };

  render() {
    const translationKeyForLink =
      this.props.profile.address1 || this.props.profile.zipCode
        ? 'common.edit'
        : 'common.add';
    return (
      <React.Fragment>
        <div ref={this.setRef} className={styles['section-read']}>
          <FlexPanel spread className={styles['section-read-title']}>
            {this.props.title && (
              <Text bold colour="grey-900">
                {t(this.props.title)}
              </Text>
            )}
            {this.props.editForm && (
              <Link
                bold
                underline
                colour="grey-900"
                id={`${this.props.editForm}-link`}
                onClick={this.state.isEditing ? this.onClose : this.onEdit}
              >
                {this.state.isEditing
                  ? t('common.close')
                  : t(translationKeyForLink)}
              </Link>
            )}
          </FlexPanel>
          {this.state.isEditing ? (
            <DynamicFormContainer
              formId={this.props.editForm}
              prefillValues={this.props.profile}
              loadingSubmit={this.props.isLoading}
              textSubmit={t('common.save')}
              textCancel={t('common.cancel')}
              onCancel={this.onClose}
              onSubmit={this.onSubmit}
            />
          ) : (
            this.props.children
          )}
        </div>
        {!this.props.isLastElement && <Divider dashboard />}
      </React.Fragment>
    );
  }
}

DashboardPrimaryAddressSectionReadContainer.propTypes = {
  title: PropTypes.string,
  editForm: PropTypes.string,
  profile: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  isLastElement: PropTypes.bool,
  // From Redux/Thunks
  updateProfile: PropTypes.func.isRequired,
  clearFormAction: PropTypes.func.isRequired,
  isLoading: PropTypes.bool
};

const mapStateToProps = state => {
  return {
    profile: state.profile,
    isLoading: state.userInterface.loading[LOADING.PROFILE_UPDATE]
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      updateProfile,
      clearFormAction
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardPrimaryAddressSectionReadContainer);
